<template>
  <div class="intro">
    <pattern-gallery class="gallery" />
    <div class="info">
      <div>
        <img class="icon" src="../assets/into-icon.svg" width="72" height="75">
        <h1 class="alt-font">Design Tool</h1>
        <p>
          Welcome to {{ brand }}'s Design Tool. This handy tool allows you to build and customize your wall installation.
        </p>
        <p>
          To start, simply click on one of the templates to the left to begin designing.
          Once in the tool, set the installation size, arrange colors, then save or email your work.
          Have a change of heart? Return to this screen by clicking on ‘pattern gallery’ to select a new template.
        </p>
        <p>
          And if you need help at any time, click ‘contact us’ at the right of your screen.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import PatternGallery from '../components/PatternGallery'

  export default {
    components: {
      PatternGallery
    },
    computed: {
      brand () {
        return this.$route.params.brand === 'filzfelt'
          ? 'FilzFelt'
          : 'Spinneybeck'
      }
    }
  }
</script>

<style>
  .intro {
    display: flex;
    margin-bottom: 3.5em;
  }

  .info {
    margin-left: 20px;
    flex: 0 0 300px;
  }

  .icon {
    display: block;
    margin: auto;
  }

  .gallery {
    flex: 0 1 auto;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// Intro.vue?71055fc2